import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { Global } from '../classes/Global';
import { Router } from '@angular/router';
import { DateHelper } from '../helpers/DateHelper';
import { StorageHelper } from '../helpers/StorageHelper';

@Component({
  selector: 'app-categories-bar',
  templateUrl: './categories-bar.component.html',
  styleUrls: ['./categories-bar.component.scss']
})
export class CategoriesBarComponent extends BaseComponent implements OnInit {

  showMore: boolean = false;
  maxItemsDisplayed: number = 12;

  lists: any[] = [];

  constructor(
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.lists = [
      {
        store: Global.ITUNES, categories: [
        {title:"movies", color:"red", mediaType:Global.BUYMOVIES,
        items: [
          {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:this.getString('blackFridayDealsUrl') },
          {title: "onsale", icon:"list", listType: Global.ON_SALE, url: this.getString('onSaleUrl') },
          {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
          {title: "movieBundles", icon:"list", listType:Global.BUNDLES, url: this.getString('movieBundlesUrl')},
          {title: "movies4K", icon:"list", listType:Global.MOVIES_4K, url: this.getString('movie4kUrl')},
          {title: "upgradedTo4K", icon:"list", listType: Global.UPGRADED_4K, url: this.getString('upgradedTo4kUrl')},
          { title: "movies3D", icon: "list", listType: Global.MOVIES_3D, url: this.getString('movie3dUrl') },
          {title: "preorder", icon:"list", listType:Global.PREORDER, url: this.getString('preorderUrl')},
          {title: "allMovies", icon:"list", listType: Global.AZ, url: this.getString('allMoviesUrl')},
          {title: "justreleased", icon:"list", listType:Global.JUST_RELEASED, url: this.getString('justReleasedUrl')},
          { title: "newOnAppleTv", icon: "list", listType: Global.RECENTLYADDED, url: this.getString('newOniTunesUrl') },
          {title: "imdbTop250", icon:"list", listType:Global.IMDBTOP250, url: "/imdb-top-250"}]},

        {title:"seasons", color:"green", mediaType:Global.SEASONS,
        items: [
          {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:this.getString('blackFridayDealsUrl') },
          {title: "onsale", icon:"list", listType: Global.ON_SALE, url: this.getString('onSaleUrl') },
          {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
          {title: "tvBundles", icon:"list", listType:Global.BUNDLES, url: this.getString('seasonsBundlesUrl')},
          {title: "allSeasons", icon:"list", listType:Global.AZ, url: this.getString('allSeasonsUrl')},
              { title: "newOnAppleTv", icon: "list", listType: Global.RECENTLYADDED, url: this.getString('newOniTunesUrl') }]
          },

        {title:"apps", color:"darkblue", mediaType:Global.APPS,
        items: [
          {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:this.getString('blackFridayDealsUrl') },
          {title: "onsale", icon:"list", listType: Global.ON_SALE, url: this.getString('onSaleUrl') },
          {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
          {title: "allApps", icon:"list", listType:Global.AZ, url: this.getString('allAppsUrl')},
          { title: "allAppsVisionPro", icon: "list", listType: Global.VISION_PRO_APPS, url: this.getString('allAppsVisionProUrl') },
          {title: "currentlyForFree", icon:"list", listType:Global.NOW_FREE, url: this.getString('nowFreeUrl')},
          {title: "newInAppStore", icon:"list", listType:Global.RECENTLYADDED, url: this.getString('newOniTunesUrl')}]},

        {title:"macapps", color:"darkblue", mediaType:Global.MACAPPS,
        items: [
          {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:this.getString('blackFridayDealsUrl') },
          {title: "onsale", icon:"list", listType: Global.ON_SALE, url: this.getString('onSaleUrl') },
          {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
          {title: "allMacApps", icon:"list", listType:Global.AZ, url: this.getString('allMacAppsUrl')},
          {title: "currentlyForFree", icon:"list", listType:Global.NOW_FREE, url: this.getString('nowFreeUrl')},
          {title: "newInMacAppStore", icon:"list", listType:Global.RECENTLYADDED, url: this.getString('newOniTunesUrl')}]},

        {title:"music", color:"lila", mediaType:Global.ALBUMS,
        items: [
          {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:this.getString('blackFridayDealsUrl') },
          {title: "onsale", icon:"list", listType: Global.ON_SALE, url: this.getString('onSaleUrl') },
          {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
          {title: "allMusic", icon:"list", listType:Global.AZ, url: this.getString('allMusicUrl')},
          {title: "greatestHits", icon:"list", listType:Global.GREATESTHITS, url: "/greatest-hits"},
              { title: "newOnAppleMusic", icon: "list", listType: Global.RECENTLYADDED, url: this.getString('newOniTunesUrl') }]
          },

        {title:"ebooks", color:"purple", mediaType:Global.EBOOKS,
        items: [
          {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:this.getString('blackFridayDealsUrl') },
          {title: "onsale", icon:"list", listType: Global.ON_SALE, url: this.getString('onSaleUrl') },
          {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
          {title: "allEbooks", icon:"list", listType:Global.AZ, url: this.getString('allBooksUrl')},
          {title: "currentlyForFree", icon:"list", listType:Global.NOW_FREE, url: this.getString('nowFreeUrl')},
              { title: "newOnAppleBooks", icon: "list", listType: Global.RECENTLYADDED, url: this.getString('newOniTunesUrl') }]
          },

        {title:"audiobooks", color:"mint", mediaType:Global.AUDIOBOOKS,
        items: [
          {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:this.getString('blackFridayDealsUrl') },
          {title: "onsale", icon:"list", listType: Global.ON_SALE, url: this.getString('onSaleUrl') },
          {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
          {title: "allAudiobooks", icon:"list", listType:Global.AZ, url: this.getString('allAudiobooksUrl')},
            { title: "newOnAppleBooks", icon: "list", listType: Global.RECENTLYADDED, url: this.getString('newOniTunesUrl') }]
        }
        ]
      },
      {
        store: Global.AMAZON, categories:
        [
          {
            title:"movies", color:"red", mediaType:Global.BUYMOVIES,
            items: [
              {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:this.getString('blackFridayDealsUrl') },
              {title: "onsale", icon:"list", listType: Global.ON_SALE, url: this.getString('onSaleUrl') },
              {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
              {title: "allMovies", icon:"list", listType: Global.AZ, url: this.getString('allMoviesUrl')},
              { title: "newOnPrimeVideo", icon: "list", listType: Global.NEW_ON_PRIME_VIDEO, url: this.getString('newOnPrimeVideoUrl') },
            ]
          },
          {
            title:"seasons", color:"green", mediaType:Global.SEASONS,
            items: [
              {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:this.getString('blackFridayDealsUrl') },
              {title: "onsale", icon:"list", listType: Global.ON_SALE, url: this.getString('onSaleUrl') },
              {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
              {title: "allSeasons", icon:"list", listType:Global.AZ, url: this.getString('allSeasonsUrl')},
            ]
          }
          ]
      },
      {
        store: Global.VUDU, categories:
        [
          {
            title:"movies", color:"red", mediaType:Global.BUYMOVIES,
            items: [
              {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:this.getString('blackFridayDealsUrl') },
              {title: "onsale", icon:"list", listType: Global.ON_SALE, url: this.getString('onSaleUrl') },
              {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
              {title: "movieBundles", icon:"list", listType:Global.BUNDLES, url: this.getString('movieBundlesUrl')},
              {title: "allMovies", icon:"list", listType: Global.AZ, url: this.getString('allMoviesUrl')},
              // { title: "top200", icon: "list", listType: Global.TOP_200, url: "top-200" }, // Temporarily disabled
              { title: "comingSoon", icon: "list", listType: Global.COMING_SOON, url: "coming-soon" },
              { title: "newReleases", icon: "list", listType: Global.NEW_RELEASES, url: "new-releases" },
              { title: "newMovies", icon: "list", listType: Global.NEW_MOVIES, url: "new-movies" },
              { title: "movies4K", icon: "list", listType: Global.MOVIES_IN_4K, url: "4k" },
              { title: "newTo4k", icon: "list", listType: Global.NEW_TO_4K, url: "new-to-4k" }
            ]
            },
            {
              title: "seasons", color: "green", mediaType: Global.SEASONS,
              items: [
                { title: 'blackFriday', icon: 'list', listType: Global.BLACK_FRIDAY, url: this.getString('blackFridayDealsUrl') },
                { title: "onsale", icon: "list", listType: Global.ON_SALE, url: this.getString('onSaleUrl') },
                { title: "charts", icon: "list", listType: Global.CHARTS, url: "charts" },
                { title: "tvBundles", icon: "list", listType: Global.BUNDLES, url: this.getString('seasonsBundlesUrl') },
                { title: "allSeasons", icon: "list", listType: Global.AZ, url: this.getString('allSeasonsUrl') },
                { title: "newSeasons", icon: "list", listType: Global.NEW_SEASONS, url: "new-seasons" },
                { title: "seasons4K", icon: "list", listType: Global.SEASONS_IN_4K, url: "4k-seasons" },
                { title: "classicSeasons", icon: "list", listType: Global.CLASSIC_SEASONS, url: "classic-seasons" }
              ]
          }
          ]
      },
      {
        store: Global.GOOGLEPLAY, categories:
        [
          {
            title:"movies", color:"red", mediaType:Global.BUYMOVIES,
            items: [
              {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:this.getString('blackFridayDealsUrl') },
              {title: "onsale", icon:"list", listType: Global.ON_SALE, url: this.getString('onSaleUrl') },
              {title: "allMovies", icon:"list", listType: Global.AZ, url: this.getString('allMoviesUrl')},
            ]
          }
          ]
      }
    ];
    for(let list of this.lists) {
      for(let cat of list.categories) {

        if(!DateHelper.isBlackFriday()) {
          if(cat.items.map(i => i.listType).indexOf(Global.BLACK_FRIDAY) >= 0) {
            cat.items.splice(0, 1); //remove black friday when it's not. assumes black friday is the first in the list
          }
        }

      }
    }
    this.showMoreIfItemIsUnderMore();
  }

  getLink(listType: string): string {
    return '/' + Global.getCountry() + "/" + Global.getStoreUrl() + '/' + Global.getMediaTypeForUrl() + '/' + listType;
  }

  getItems() {
    let items = [];
    const storeList = this.lists.filter(l => l.store == Global.getStore())[0];
    if(storeList) {
      let mediaType = this.getMediaType();
      if(mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
        mediaType = Global.MOVIES;
      }
      if(mediaType == Global.ALBUMS || mediaType == Global.SINGLES) {
        mediaType = Global.MUSIC;
      }
      const category = storeList.categories.filter(l => l.title == mediaType)[0];
      if(category) {
        items = category.items;
      }
    }

    //If the new selection does not include the current listType, got to on sale
    const listType: string = Global.getListType();
    if(listType != Global.BLACK_FRIDAY && !items.map(i => i.listType).includes(listType)) {
      this.router.navigate([this.getLink(this.getString('onSaleUrl'))]);
    }

    return items;
  }

  isSelected(item): boolean {
    return Global.getListType() == item.listType;
  }

  getMediaType(): string {
    let mediaType = Global.getMediaType();
    if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES){
      mediaType = Global.MOVIES;
    }
    else if(mediaType == Global.ALBUMS) {
      mediaType = Global.MUSIC;
    }
    return mediaType;
  }

  logEvent(category: string) {
    if((<any>window).gtag) {
      (<any>window).gtag('event', category, {
        'event_category': "Browse"
      });
    }
    if ((<any>window)._paq) {
      (<any>window)._paq.push(['trackEvent', "Browse", category]);
    }
  }

  showMoreIfItemIsUnderMore() {
    const items = this.getItems();
    for(let i = 0; i < items.length; i++) {
      if(i > this.maxItemsDisplayed && this.isSelected(items[i])) {
        this.showMore = true;
        break;
      }
    }
  }

  itemClicked(item) {
    this.logEvent(item.title);
    StorageHelper.getInstance().clear(item.listType + '_' + StorageHelper.keys.sort);
  }

}
